// @flow

import { reduce } from '../../network/reduce';

export type initialStateType = {
  +mapsApiKey: ?string,
}

const initialState: initialStateType = {
  mapsApiKey: undefined,
};

export const SET_MAPS_API_KEY = 'SET_MAPS_API_KEY';

const googleServicesReducer = reduce(initialState, {
  [SET_MAPS_API_KEY]: 'mapsApiKey',
});

export default googleServicesReducer;
